import { motion } from "framer-motion";
import React from "react";
import { images } from "../../constants";

const About = () => {
  return (
    <div className="app__home-body-left" id="about">
      <div className="app__home-body-left-img">
        <div id="left-right-img">
          <img src={images.mapPortrait} alt="app-pages" />
        </div>
      </div>
      <motion.div
        whileInView={{ x: [100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__home-body-left-text"
      >
        <h1>Let's make this a reality!</h1>
        <p>
          <span style={{ fontWeight: 700 }}>Open For Conversation</span> is your
          go-to app for sparking real-life connections in a digital world. Say
          goodbye to superficial online interactions and hello to spontaneous
          meetups with like-minded people nearby!
        </p>
        <div className="app__home-body-button">
          <a
            href="https://forms.gle/R3iWjC4E7DDXuQnV9"
            target="_blank"
            rel="noreferrer"
          >
            Give us feedback!
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default About;
